<template>
  <div class="center-cmp">
        <!-- <v-chart class="chart" :option="option" autoresize /> -->
         <!-- <div id="map" style="height: 100%; "> </div> -->
            <img  :src="require('@/assets/map.png')"/>
  </div>
</template>

<script>

import axios from 'axios';
const icon1 = require('@/assets/img/map1.png')

export default {
    name: 'LayoutCenter1C',
    components: {
        // VChart,
    },
    provide: {
        // [THEME_KEY]: 'dark',
    },

    data() {
        return {
            list: null,
            map: null,
            citys: null,
        }
    },
    props: {
    },
    watch: {
        mapOption: {
            // handler(options) {
                // this.mapChart.setOption(options, true)
            // },
            deep: true
        }
    },
    methods: {
        init() {

        },
        addMark(element) {
            var pt = new window.BMapGL.Point(element.longitude, element.latitude);
            var ismain = element.id == 10127 ? true : false
            var marker = new window.BMapGL.Marker3D(pt, 1300, {
                size: 15,
                shape: 1,
                fillColor: ismain ? '#f00' : '#454399',
                fillOpacity: 0.8
            });
            this.map.addOverlay(marker);
        },
        addMark1(element) {
            var pt = new window.BMapGL.Point(element.longitude, element.latitude);
            // var ismain = element.id == 10127 ? true : false
            var icon = new window.BMapGL.Icon(icon1, new window.BMapGL.Size(10, 12))

            var marker = new window.BMapGL.Marker(pt, {
                icon: icon
            });
            this.map.addOverlay(marker);
        },
        loadList() {
            var that = this;
            axios.get(this.$store.state.config.host + "/big/site/")
            .then(response => {
                var list = []

                var cityGet = new window.BMapGL.Geocoder();
                Object.values(response.data.data).forEach(element => {
                    list.push({
                        name: element.city_text,
                        city: element.city,
                    })
                    if (element.longitude !== '0.0') {
                        // var marker = new BMapGL.Marker(new BMapGL.Point(element.longitude, element.latitude))
                        // that.map.addOverlay(marker)
                        // that.addMark1(element)
                    } else {
                        cityGet.getPoint(element.city_text + element.address, function(point) {
                            if (point) {
                                element.longitude = point.lng
                                element.latitude = point.lat
                                // that.addMark1(element)

                                axios.get(that.$store.state.config.host + "/big/upsite/?id=" + element.id 
                                + '&longitude=' + element.longitude
                                + '&latitude=' + element.latitude)
                            }
                        });
                    }
                    
                });
                that.list = list

                var cityIndex = 0;
                setInterval(() => {
                    that.$emit('click-city', that.list[cityIndex])

                    cityIndex += 1
                    if (cityIndex > 13) {
                        cityIndex = 0
                    }
                    // console.log(cityIndex)
                    // console.log(that.list[cityIndex])
                }, 10000);
            })
        },
        loadCity() {
            var that = this;
            axios.get(this.$store.state.config.host + "/big/map/")
            .then(response => {
                var list = []
                Object.values(response.data.data).forEach(element => {
                    list.push({
                        name: element.city_text,
                        city: element.city,
                        scene: element.scene,
                        value: element.attendance
                    })
                    
                    // var fcolor = '#f18b18'
                    // var scolor = '#daeafa'
                    // that.addDistrict(element.city_text, 0, fcolor, scolor)
                });
                that.citys = list

                // var cityIndex = 0
                // setInterval(() => {
                //     that.$emit('click-city', that.citys[cityIndex])
                //     cityIndex += 1
                //     if (cityIndex > 13) {
                //         cityIndex = 0
                //     }
                // }, 10000);
            })
        },
        addDistrict(name, prokind, fcolor, scolor) {
            const BMapGL = window.BMapGL

            var dist = null
            dist = new BMapGL.DistrictLayer({
                name: '(' + name + ')',
                kind: prokind,
                fillColor: fcolor,
                strokeColor: scolor,
                viewport: true
            });
            this.map.addDistrictLayer(dist);
        }
    },
    mounted() {
        // this.loadList()
        this.$nextTick(() => {
                // console.log("BMapGL", window.BMapGL)
                /*
            const BMapGL = window.BMapGL
            var map = new BMapGL.Map('map', {
                minZoom: 5,
                maxZoom: 20 
            });
            map.centerAndZoom(new BMapGL.Point(116.404, 39.915), 7);
            map.enableScrollWheelZoom();
            var zoomCtrl = new BMapGL.ZoomControl();
            map.addControl(zoomCtrl);

            this.map = map;
            this.map.removeDistrictLayer(null);

            this.addDistrict('湖南省', 1, '#118bf8', '#daeafa')

            this.loadList();
            this.loadCity();

            // this.map.updateFocusOptions({
            //     open: true,
            //     gray: true, // 是否使用灰度图模式
            //     involve: 0, // 0 底图面线+图层 1 底图poi 2 覆盖物
            //     focus: -1, // -1 全部地图使用other着色，此配置不需要商业授权；0 局部，此配置不需要商业授权
            //     other: [28, 12, 18]
            // });

            // var styleJson = [
            //     {
            //         "featureType": "land",
            //         "elementType": "geometry",
            //         "stylers": {
            //             "visibility": "on",
            //             "color": "#091220ff"
            //         }
            //     }, {
            //         "featureType": "water",
            //         "elementType": "geometry",
            //         "stylers": {
            //             "visibility": "on",
            //             "color": "#113549ff"
            //         }
            //     }]
            this.map.setMapStyleV2({styleId: "de963c11acd66c9a34cba648195df4a2"})
*/

        })
            this.loadList();
            // this.loadCity();
    },
};
</script>

<style lang="less">
.center-cmp {
  width: 100%;
  height: 100%;
  margin: 0px;
  padding: 0px;
  display: flex;
  flex-direction: column;
}
</style>

